import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const SectionWrapper = styled(Box)(({ theme }) => ({
    padding: 24,
    borderRadius: 4,
    backgroundColor: 'white',
    maxWidth: '544px',
    border: '1px solid',
      // @ts-ignore: Accessing theme prop since we have extended palette
    borderColor: theme.palette.common.grey3
}));
export default SectionWrapper;
